import Analytics from '@opencare/analytics';
import PropTypes from 'prop-types';
import React, { useState } from 'react';

import {
  Div,
  FilledGhostButton,
  P,
  VisuallyHidden,
} from 'common/styles/oc-styled-components';
import { colors } from 'common/styles/style-constants';
import {
  DIMENSIONS,
  useWindowDimensions,
} from 'providers/WindowDimensionsProvider';

import OpencareRewardsModal from '../../../results/components/OpencareRewardsModal/OpencareRewardsModal';

import { Container, Copy } from './styled-components';

const analytics = new Analytics();

// Component
const OfferBanner = ({ offerName, isThirdPartyOffer }) => {
  const { layout } = useWindowDimensions();
  const [
    opencareRewardsModalVisible,
    setOpencareRewardsModalVisible,
  ] = useState(false);

  const openOfferModal = () => {
    analytics.trackClick({
      pageType: analytics.pageTypes.FUNNEL,
      name: 'funnel-offer-banner',
      section: 'see-how',
    });

    setOpencareRewardsModalVisible(true);
  };

  return (
    <Div background={colors.coralDark} data-testid="offer-banner">
      <Container justify="space-between" align="center" height="60px">
        <VisuallyHidden>
          Reward your smile.
          {isThirdPartyOffer ? offerName : `Get a ${offerName}`}.
        </VisuallyHidden>
        <Copy aria-hidden>
          <P
            fontSize={layout === DIMENSIONS.MOBILE ? '14px' : '18px'}
            color={colors.white}
            margin="0 4px 0 0"
          >
            Reward your smile.
          </P>
          <P
            fontSize={layout === DIMENSIONS.MOBILE ? '14px' : '18px'}
            fontWeight="900"
            color={colors.white}
            margin="0 4px 0 0"
          >
            {isThirdPartyOffer ? offerName : `Get a ${offerName}`}.
          </P>
        </Copy>
        <FilledGhostButton
          shape="round"
          color={colors.coralDark}
          onClick={openOfferModal}
          data-testid="offer-cta"
        >
          See How
        </FilledGhostButton>
      </Container>
      <OpencareRewardsModal
        offerName={offerName}
        isThirdPartyOffer={isThirdPartyOffer}
        opencareRewardsModalVisible={opencareRewardsModalVisible}
        setOpencareRewardsModalVisible={setOpencareRewardsModalVisible}
      />
    </Div>
  );
};

OfferBanner.propTypes = {
  isThirdPartyOffer: PropTypes.bool,
  offerName: PropTypes.string.isRequired,
};

export default OfferBanner;
